export const BASE_API_URL = "https://hos-smartbillingv2-api.azurewebsites.net/";
export const SIGN_IN_URL = BASE_API_URL + "login/login";
export const IS_OLD_USER = BASE_API_URL + "user/isOldUser";
export const SIGN_UP_URL = BASE_API_URL + "user/createUser";
export const FORGET_PASSWORD_URL = BASE_API_URL + "user/forgetPassword";
export const WEB_ENCRYPTION_URL = BASE_API_URL + "Crypto/WebEncryption";
export const WEB_DECRYPTION_URL = BASE_API_URL + "Crypto/WebDecryption";
export const USERS_BY_ID_URL = BASE_API_URL + "user/getUserById";
export const USERLOG_LIST_URL=BASE_API_URL+"user/getAllUsers"
export const USER_FILTER_LIST_URL=BASE_API_URL+"user/getUserFilter"
export const UPDATE_USER_BY_ID = BASE_API_URL + "user/updateUser";
export const GET_ALL_CUSTOMERS_URL = BASE_API_URL + "customer/getAllCustomers";
export const GET_ALL_CUSTOMER_FILTER_URL = BASE_API_URL + "customer/getCustomerFilter";
export const GET_CUSTOMER_BY_ID_URL = BASE_API_URL + "customer/getCustomerById";
export const UPSERT_CUSTOMERS_URL = BASE_API_URL + "customer/UpsertCustomer";
export const GET_CUSTOMER_ALL_LOG_FILTER_URL = BASE_API_URL + "user/getUserLogFilter";
export const GET_TYPES_FILTER_URL = BASE_API_URL + "user/userFilterOptionsByCategoryId";
export const GET_ALL_PROJECTS_URL = BASE_API_URL + "project/getAllProjects";
export const UPSERT_PROJECT_URL = BASE_API_URL + "project/upsertProject";
export const GET_ALL_PROJECT_FILTER_URL = BASE_API_URL + "project/getProjectFilter";
export const GET_PROJECT_DETAILS_BY_ID_URL = BASE_API_URL + "project/getProjectById";
export const ADD_UPDATE_BROKER_URL = BASE_API_URL + "project/upsertProjectBroker";
export const ADD_UPDATE_LOCATION_URL = BASE_API_URL + "project/upsertProjectLocation";
export const GET_ALL_BROKERS = BASE_API_URL + "project/getAllBrokers";
export const GET_PROJECT_BROKER_DETAILS_BY_ID_URL =
  BASE_API_URL + "project/getProjectLocationById";
  export const GET_PROJECT_LOCATION_DETAILS_BY_ID_URL =
    BASE_API_URL + "/project/getProjectBrokerById";
export const GET_ALL_STATE_LIST_URL = BASE_API_URL + "project/getAllState";
export const GET_COUNTY_LIST_BY_STATE_URL =
  BASE_API_URL + "project/getCountylistBystate";
export const GET_ALL_BILLING_FILTER_URL = BASE_API_URL + "billStatement/getBillingFilter"
export const CREATE_UPDATE_BILLING_STATEMENT_URL =
  BASE_API_URL + "billStatement/upsertBillingStatement";

export const DELETE_BILLING_STATEMENT_BY_ID =
  BASE_API_URL + "billStatement/deleteBillingStatementDetailsById";
export const UPDATE_BILLING_STATUS_URL =
  BASE_API_URL + "billStatement/updateBillingStatus";
export const GET_BILLING_STATEMENT_DETAILS_BY_ID_URL =
  BASE_API_URL + "billStatement/getBillingStatementDetailsById";
export const CREATE_UPDATE_BILLING_STATEMENT_DETAILS_URL =
  BASE_API_URL + "billStatement/upsertBillingStatementDetails";
export const GET_BILLING_STATEMENT_BY_ID_URL =
  BASE_API_URL + "billStatement/getBillingStatementById";
export const GET_DASHBOARD_BILLING_STATEMENT_BY_ID_URL =
  BASE_API_URL + "dashboard/getDashboardBillingStatementById";

export const GET_BROKER_BILLING_URL = BASE_API_URL + "billStatement/getBrokerBilling";

export const GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL = BASE_API_URL + "billStatement/getAttachmentByBillingProject";
export const INSERT_INVOICE_ATTCHMEMNTS = BASE_API_URL + "invoice/insertInvoiceAttachments";
export const GET_INVOICE_PDF_ATTACHMENTS_API = BASE_API_URL + "invoice/getInvoiceAttachments";

export const GET_PERDIAM_VALUE_BY_ID_URL =
  BASE_API_URL + "project/getPerDiemByProjectId";

export const UPLOAD_FILE_URL = BASE_API_URL + "uploadFile/uploadFile";
export const UPLOAD_ATTACHMENT_LOG_URL = BASE_API_URL + "uploadFile/attachmentUpsert";
export const GET_ATTACHMENT_LOG_LIST_URL = BASE_API_URL + "billStatement/getAttachmentList";
export const DELETE_ATTACHMENT_LOG_BY_ID_URL = BASE_API_URL + "billStatement/deleteAttachment";
export const UPDATE_HAMBURGER_MENU_URL = BASE_API_URL + "user/hamburgerMenuUpdate";

export const BROKER_TO_ADMIN_URL =
  BASE_API_URL + "billStatement/insertOrphanedBillingStatementByUserId";
export const ARCHIVE_STATUS_UPDATE_URL = BASE_API_URL + "user/archiveStatusUpdate"

export const GET_ALL_INVOICE_FILTER_URL = BASE_API_URL + "invoice/getInvoiceFilter"
export const GET_ALL_INVOICE_LIST_FILTER_URL = BASE_API_URL + "invoice/getInvoiceListFilter"
export const SYSTEM_LOG_INSERT_URL = BASE_API_URL + "common/systemLogInsert";
export const GET_ALL_INVOICE_STATEMENT_BY_ID_URL = BASE_API_URL + "invoice/getInvoiceStatementById"
export const GET_ADMIN_INVOICE_STATEMENT_BY_ID = BASE_API_URL + "invoice/getAdminInvoiceStatementById"
export const UPSERT_INVOICE_STATEMENT_URL = BASE_API_URL + "invoice/upsertInvoice"
export const DELETE_INVOICE_LINE_ITEM_URL =
  BASE_API_URL + "invoice/deleteInvoiceDetailsById";
export const UPSERT_INVOICE_DETAILS_URL =
  BASE_API_URL + "invoice/upsertInvoiceDetails";
export const CHANGE_PASSWORD_URL = BASE_API_URL + "user/changePassword";
export const UPDATE_INVOICE_STATUS_URL = BASE_API_URL + "invoice/updateInvoiceStatus";
export const GET_INVOICE_DETAILS_BY_ID = BASE_API_URL + "invoice/getInvoiceById";
export const DELETE_INVOICE_ATTATCHMENTS = BASE_API_URL + "invoice/deleteAttachment";
export const GET_INVOICE_ATTATCHMENT_LIST_URL =
  BASE_API_URL + "billStatement/getAttachmentListByUserId";
export const GET_ORPHANED_BROKER_DETAILS_LIST_URL = BASE_API_URL + "billStatement/getOrphanedBrokerDetails";
export const UPDATE_INVOICE_BILLING_ADDRESS =
  BASE_API_URL + "invoice/updateInvoiceBillingAddress";
export const GET_INVOICE_SELECTED_PERIOD_URL =
  BASE_API_URL + "invoice/getInvoiceStatementById";
export const GET_INVOICE_REPORT_URL = BASE_API_URL + "report/getInvoiceReport";
export const UPDATE_DAY_AND_MILEAGE_RATE_INVOICE_URL =
  BASE_API_URL + "invoice/upsertInvoiceProjectHeaders";
export const GET_DAY_AND_MILEAGE_RATE_URL =
  BASE_API_URL + "invoice/getInvoiceProjectHeadersById";
export const ATTACH_DETACH_INVOICE_URL =
  BASE_API_URL + "invoice/upsertAttachedDetails";
export const GET_ATTACH_NEW_STATEMENT_INVOICE_URL = BASE_API_URL + "invoice/getNewAttachStatementDetails";
export const GET_ATTACH_URL = BASE_API_URL + "invoice/getAttachedDetailsById";
  export const GET_PROXY_PDF =
  BASE_API_URL + "user/proxy";

export const CHECK_STATEMENT_EXIST_IN_INVOICE_URL = BASE_API_URL + "invoice/checkStatementExistsInInvoice";
  
  export const GET_BROKER_YETOSTART_BILLINGSTATEMENT = BASE_API_URL + "invoice/getBrokerYetToStartBillingStatement";

  export const GET_PROJECTS_ID = BASE_API_URL + 'project/getProjectsById';
//Report

export const GET_REPOT_BILLING_STATEMENT = BASE_API_URL + 'report/getBillingStatementReport';

//DashBoard Api's:

export const  GET_DASHBOARD_BILLING_BY_DAY = BASE_API_URL + 'dashboard/getBillingByDay'
export const  GET_BROKER_BILLING_TYPE_GRAPH = BASE_API_URL + 'dashboard/getBrokerBillingTypeGraph'
export const  GET_HEADER_STATISTICS_LIST = BASE_API_URL + 'dashboard/getHeaderStatistics'
export const  GET_DASHBOARD_FILTER_LIST = BASE_API_URL + 'dashboard/getDashboardFilter'
export const  GET_PROJECT_BILLING_TYPE_GRAPH = BASE_API_URL + 'dashboard/getProjectBillingTypeGraph'
export const  GET_BILLING_TREND_MOVING_AVERAGE_GRAPH = BASE_API_URL + 'dashboard/getBillingTrendandMovingAverage'
export const  GET_BROKER_TREND_MOVING_AVERAGE_GRAPH = BASE_API_URL + 'dashboard/getBrokerTrendandMovingAverage'
export const  GET_BROKER_PROJECT_HOURS = BASE_API_URL + 'dashboard/getBrokerHoursByUserId'
export const  GET_DASHBOARD_FILTER_BROKER_LIST = BASE_API_URL + 'dashboard/getDashboardFilterBroker'
export const  GET_CUSTOMER_BROKER_HOUR_LIST = BASE_API_URL + 'dashboard/getCustomerBrokerHours'
export const  GET_PROJECT_BROKER_HOUR_LIST = BASE_API_URL + 'dashboard/getProjectBrokerHours'
export const  GET_CUSTOMER_HEADER_STATISTICS_LIST = BASE_API_URL + 'dashboard/getCustomerHeaderStatistics'
export const  GET_CUSTOMER_BROKER_STATISTICS_LIST = BASE_API_URL + 'dashboard/getBrokerHeaderStatistics'
export const  GET_PROJECT_HEADER_STATISTICS_LIST = BASE_API_URL + 'dashboard/getProjectHeaderStatistics'
export const  GET_CUSTOMER_BILLING_TYPE_GRAPH = BASE_API_URL + 'dashboard/getCustomerBillingTypeGraph'
export const  GET_PROJECT_LAG_GRAPH = BASE_API_URL + 'dashboard/getProjectLag'
export const  GET_BROKER_LAG_GRAPH = BASE_API_URL + 'dashboard/getBrokerLag'
export const  GET_BROKER_AVERAGE_LAG_GRAPH = BASE_API_URL + 'dashboard/getBrokerLag'
// export const  GET_BROKER_PROJECT_HOURS = BASE_API_URL + 'dashboard/getBrokerHoursByUserId'

//Dashboard Customer table

export const  GET_CUSTOMER_PROJECT_TABLE = BASE_API_URL + 'dashboard/getProjectTable'
export const  GET_CUSTOMER_BROKER_TABLE = BASE_API_URL + 'dashboard/getBrokerTable'
export const  GET_CUSTOMER_BILLING_TABLE = BASE_API_URL + 'dashboard/getBillingTable'
export const  GET_CUSTOMER_ACTIVITY_TABLE = BASE_API_URL + 'dashboard/getCustomerActivityTable'

//Dashboard Project table
export const  GET_PROJECT_BILLING_TABLE = BASE_API_URL + 'dashboard/getProjectBillingByProjectIdTable'
export const  GET_PROJECT_ACTIVITY_TABLE = BASE_API_URL + 'dashboard/getProjectActivityTable'

//Dashboard Broker table
export const  GET_BROKER_PROJECT_TABLE = BASE_API_URL + 'dashboard/getBrokersProjectTable'
export const  GET_BROKER_BILLING_STATEMENT_TABLE = BASE_API_URL + 'dashboard/getBrokersBillingStatementTable'
export const  GET_BROKER_BILLING_TABLE = BASE_API_URL + 'dashboard/getBrokersBillingTable'
export const  GET_BROKER_ACTIVITY_TABLE = BASE_API_URL + 'dashboard/getBrokerActivityTable'

//Dashboard Rollup
export const  GET_PROJECT_ROLLUP_HEADERS = BASE_API_URL + 'dashboard/getProjectRollupHeaders'
export const  GET_PROJECT_ROLLUP_BILLING_DETAILS = BASE_API_URL + 'dashboard/getProjectRollupBillingDetails'
export const  GET_PROJECT_ROLLUP_BILLING_TYPES = BASE_API_URL + 'dashboard/getProjectRollupBillingTypes'
export const  GET_PROJECT_ROLLUP_BROKER_LIST = BASE_API_URL + 'dashboard/getProjectRollupBrokers'
export const  GET_PROJECT_ROLLUP_BILLING_TREND = BASE_API_URL + 'dashboard/getProjectRollupBillingTrend'

//Email Confirmation
export const  USER_RESEND_EMAIL_URL = BASE_API_URL + 'user/resendEmail'

//Verify Confirmation
export const  USER_VERIFY_EMAIL_URL = BASE_API_URL + 'user/verifyEmail'
export const  USER_FORGOTPASSWORDLINKVERIFY_URL = BASE_API_URL + 'user/forgetPasswordLinkVerify'
export const  ADMIN_CHECK_STATEMENT_EXIST_IN_INVOICE_URL = BASE_API_URL + 'invoice/checkIsConsolidateInvoice'

//NTE Api's
export const  GET_USER_NTE_NOTIFICATIONS = BASE_API_URL + 'user/getUserNTENotification'
export const  UPDATE_NOTIFICATION_IS_READ = BASE_API_URL + 'dashboard/updateNotificationIsRead'
export const  UPSERT_NTE_DETAILS = BASE_API_URL + 'project/upsertNTEDetails'
export const  DELETE_NTE_DETAILS = BASE_API_URL + 'project/deleteNTEDetails'
export const  INSERT_NOTIFICATION_DETAILS = BASE_API_URL + 'dashboard/insertNotifiationDetails'

//Billing Review:

export const GET_BILLING_REVIEW_API = BASE_API_URL + 'billStatement/getNteBillingDetails'